// Meta (Facebook) Pixel.
//
// Entirely inert unless REACT_APP_META_PIXEL_ID is set at build time, so local
// dev and preview builds never send events. Set it in Cloudflare Pages env vars
// for production only.
//
// GDPR (CLAUDE.md constraint #4): the pixel drops cookies and sends behavioural
// data to Meta. EU/UK visitors must consent BEFORE it loads. `initMetaPixel()`
// is therefore not called on page load — it is called by the consent banner once
// the visitor accepts. Until then nothing is loaded and nothing is sent.

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let loaded = false;

function injectPixelScript() {
  if (loaded || typeof window === 'undefined' || window.fbq) return;
  /* eslint-disable */
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  loaded = true;
}

/** Load the pixel and send the first PageView. Call only after consent. */
export function initMetaPixel() {
  if (!PIXEL_ID || typeof window === 'undefined') return;
  injectPixelScript();
  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}

/** True once the visitor has consented and the pixel is live. */
export function pixelReady() {
  return Boolean(PIXEL_ID && typeof window !== 'undefined' && window.fbq && loaded);
}

/** Standard event, e.g. track('Lead', { content_name: 'Paris' }). */
export function track(event, params = {}) {
  if (!pixelReady()) return;
  window.fbq('track', event, params);
}

/** Custom event outside Meta's standard list. */
export function trackCustom(event, params = {}) {
  if (!pixelReady()) return;
  window.fbq('trackCustom', event, params);
}

/** SPA route change — Meta needs an explicit PageView per virtual navigation. */
export function trackPageView() {
  track('PageView');
}
